"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatTransaction = void 0;
var common_1 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var formatTransaction = function (t, account) { return "\nSEND ".concat((0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), t.amount, {
    showCode: true,
    disableRounding: true
}), "\nTO ").concat(t.recipient); };
exports.formatTransaction = formatTransaction;
var fromTransactionRaw = function (tr) {
    var common = (0, common_1.fromTransactionCommonRaw)(tr);
    return __assign(__assign({}, common), { family: tr.family });
};
var toTransactionRaw = function (t) {
    var common = (0, common_1.toTransactionCommonRaw)(t);
    return __assign(__assign({}, common), { family: t.family });
};
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: fromTransactionRaw,
    toTransactionRaw: toTransactionRaw
};
//# sourceMappingURL=transaction.js.map